// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project {
  --icon-link-list-gap: var(--project-icons-gap);
  --icon-link-size: var(--project-icons-size);

  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  box-shadow: var(--box-shadow);
  border: var(--box-border);
  border-radius: 0 0 var(--box-radius) var(--box-radius);

  transition: 0.4s;
}

.project__preview {
  grid-area: img;
  width: 100%;
}

.project__info {
  flex: 1;

  display: grid;
  grid-template-areas:
    "img img"
    "title links"
    "description description";

  grid-template-columns: 1fr min-content;
  grid-template-rows: min-content min-content 1fr;

  padding: var(--project-info-padding);
  gap: var(--project-info-gap);

  border-top: var(--box-border);
}

.project__title {
  grid-area: title;
  font-size: var(--h3-fontsize);
}

.project__description {
  grid-area: description;

  font-size: var(--project-description-fontsize);
  color: var(--col-txt-p);
}

.project__links {
  grid-area: links;
}

/* Hover styles */

/* when hover is supported */

.project:active {
  transform: scale(var(--box-scale-hover));
  box-shadow: var(--box-shadow-hover);
}

@media not all and (hover: none) {
  .project:hover {
    transform: scale(var(--box-scale-hover));
    box-shadow: var(--box-shadow-hover);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/projectDiv.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,2CAA2C;;EAE3C,aAAa;EACb,sBAAsB;;EAEtB,WAAW;EACX,YAAY;;EAEZ,6BAA6B;EAC7B,yBAAyB;EACzB,sDAAsD;;EAEtD,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,OAAO;;EAEP,aAAa;EACb;;;6BAG2B;;EAE3B,sCAAsC;EACtC,+CAA+C;;EAE/C,oCAAoC;EACpC,4BAA4B;;EAE5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;;EAEtB,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB,4BAA4B;;AAE5B;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE;IACE,wCAAwC;IACxC,mCAAmC;EACrC;AACF","sourcesContent":[".project {\r\n  --icon-link-list-gap: var(--project-icons-gap);\r\n  --icon-link-size: var(--project-icons-size);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  box-shadow: var(--box-shadow);\r\n  border: var(--box-border);\r\n  border-radius: 0 0 var(--box-radius) var(--box-radius);\r\n\r\n  transition: 0.4s;\r\n}\r\n\r\n.project__preview {\r\n  grid-area: img;\r\n  width: 100%;\r\n}\r\n\r\n.project__info {\r\n  flex: 1;\r\n\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"img img\"\r\n    \"title links\"\r\n    \"description description\";\r\n\r\n  grid-template-columns: 1fr min-content;\r\n  grid-template-rows: min-content min-content 1fr;\r\n\r\n  padding: var(--project-info-padding);\r\n  gap: var(--project-info-gap);\r\n\r\n  border-top: var(--box-border);\r\n}\r\n\r\n.project__title {\r\n  grid-area: title;\r\n  font-size: var(--h3-fontsize);\r\n}\r\n\r\n.project__description {\r\n  grid-area: description;\r\n\r\n  font-size: var(--project-description-fontsize);\r\n  color: var(--col-txt-p);\r\n}\r\n\r\n.project__links {\r\n  grid-area: links;\r\n}\r\n\r\n/* Hover styles */\r\n\r\n/* when hover is supported */\r\n\r\n.project:active {\r\n  transform: scale(var(--box-scale-hover));\r\n  box-shadow: var(--box-shadow-hover);\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  .project:hover {\r\n    transform: scale(var(--box-scale-hover));\r\n    box-shadow: var(--box-shadow-hover);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
